// extracted by mini-css-extract-plugin
export default {"root":"style_root___5Jdb","stickyBtn":"style_stickyBtn__fa3ue"};